@if (error()) {
  <div class="ts ts--error" role="alert">
    <nz-icon nzType="warning" nzTheme="fill" />
    <div class="ts-text">
      <p class="ts-title">{{ errorTitle() }}</p>
      <p class="ts-sub">Nothing was changed — the list reappears once the request succeeds.</p>
    </div>
    <button nz-button nzSize="small" (click)="retry.emit()">
      <nz-icon nzType="reload" />
      Retry
    </button>
  </div>
} @else {
  <div class="ts">
    <p class="ts-title">{{ emptyTitle() }}</p>
    @if (emptyHint()) {
      <p class="ts-sub">{{ emptyHint() }}</p>
    }
  </div>
}
